<div aria-label="Navigation is not enabled">
  @if (cueSolutionValidLicence() === false) {
    <h2>{{ 'navigation.invalidCueLicence' | transloco }}</h2>
  } @else if (enabled() !== true) {
    <h2>{{ 'navigation.notEnabled' | transloco }}</h2>
  }

  <img src="assets\images\navigation\background.png" alt="Navigation is not enabled" />
</div>
